import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden flex items-center justify-center bg-[#1B4D3E]" data-id="element-85">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full z-0" data-id="element-86">
        <div className="absolute inset-0 bg-[#1B4D3E]/70 mix-blend-multiply z-10" data-id="element-87" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-[#1B4D3E] z-10" data-id="element-88" />
        <video autoPlay loop muted playsInline className="w-full h-full object-cover opacity-60" style={{
        objectFit: 'cover'
      }} data-id="element-89">
          <source src="https://cdn.magicpatterns.com/uploads/psFTyREceMWnRzhNQ6imLM/WhatsApp_Video_2026-01-16_at_01.09.05_(1).undefined" type="video/mp4" data-id="element-90" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-92">
          <h2 className="text-[#D4AF37] font-sans text-sm md:text-base tracking-[0.3em] uppercase mb-6 font-semibold" data-id="element-93">
            Flicker Digital Africa
          </h2>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-medium text-white tracking-tight mb-8 leading-[1.1]" data-id="element-94">
            Creating <span className="italic text-[#D4AF37]" data-id="element-95">Meaningful</span>
            <br data-id="element-96" />
            Impact in a Digital World
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto mb-12 leading-relaxed font-light border-l-2 border-[#D4AF37] pl-6 text-left md:text-center md:border-l-0 md:pl-0" data-id="element-97">
            We blend strategy, creativity, and data to build campaigns that
            capture attention and drive real results.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row gap-6 justify-center items-center" data-id="element-98">
          <a href="#contact" className="group px-10 py-4 bg-[#D4AF37] text-[#1B4D3E] text-lg font-bold uppercase tracking-widest hover:bg-[#F4CF57] transition-all duration-500 flex items-center shadow-[0_0_30px_rgba(212,175,55,0.2)] hover:shadow-[0_0_40px_rgba(212,175,55,0.4)]" data-id="element-99">
            Work With Us
            <ArrowRight className="ml-3 h-5 w-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-100" />
          </a>
          <a href="#services" className="px-10 py-4 bg-transparent border border-white/30 text-white text-lg font-medium uppercase tracking-widest hover:bg-white/10 hover:border-white/60 transition-all duration-300 backdrop-blur-sm" data-id="element-101">
            Explore Services
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-20" data-id="element-102">
        <div className="flex flex-col items-center gap-2" data-id="element-103">
          <span className="text-[#D4AF37] text-xs tracking-widest uppercase writing-mode-vertical" data-id="element-104">
            Scroll
          </span>
          <div className="w-[1px] h-16 bg-gradient-to-b from-[#D4AF37] to-transparent" data-id="element-105" />
        </div>
      </motion.div>
    </section>;
}